export const DIALOG = 'DIALOG'

export const SETTINGS = 'SETTINGS'

export const AGENT = 'AGENT'

export const EVALUATION = 'EVALUATION'
